import { NUMBER } from "../../../constants/app-constants";

export const SLIDER_SETTINGS = {
    slidesToShow: NUMBER.ONE_POINT_THREE,
    slidesToScroll: NUMBER.ONE,
    infinite: false,
    arrow: false,
    dots: true,
    autoplay: false
};

export const videoStyleWrapper = {
    margin: "auto",
    position: "absolute",
    top: 0,
    bottom: 0
};
